import { CustomAction, WappMode } from '@weblite-wapps/protocol'
import {
  dispatchAddToWappPool,
  dispatchRemoveFromWappPool,
  dispatchSetWappBookmarkData,
  dispatchSetWappCustomActions,
  dispatchSetWapprunnerStage,
} from './wapprunnerPool.action'
import { wappSystemApi } from '../setup/root'
import {
  asyncDelay,
  BookmarkData,
  generateWappElementName,
  generateWappSessionId,
  WappSessionCreator,
  WappStage,
} from '../common'
import {
  stopWappSessionTime,
  submitWappSessionRunTime,
  submitWappSessionStartTime,
} from '../analytics'
import {
  findRunningWapp,
  getWappSession,
  proneRedundantWapps,
} from './wapprunnerPool.helper'
import { Listeners, WappRunnerEvent } from '../listeners'
import { removeFromConnectedWapps } from './connected-wapps'

export const setWappStage = (stage: WappStage) => (wappSessionId: string) => {
  if (!wappSessionId) return

  dispatchSetWapprunnerStage({ wappSessionId, stage })
  if (stage === WappStage.RUNNING) submitWappSessionRunTime(wappSessionId)
}

export const removeFromWappPool = (wappSessionId: string) => {
  const wappSession = getWappSession(wappSessionId)
  if (!wappSession) return

  removeFromConnectedWapps(wappSessionId)

  Listeners.notify(WappRunnerEvent.UNMOUNT, wappSessionId)
  stopWappSessionTime(wappSessionId)
  dispatchRemoveFromWappPool(wappSessionId)

  if (wappSession.mode === WappMode.MAIN)
    wappSystemApi.disableConfirmationOnBackClick()
}

export const addToWappPool = async (wapp: WappSessionCreator) => {
  const { wappSessionId: initialWappSessionId, wappId } = wapp
  const wappSessionId = initialWappSessionId || generateWappSessionId()
  const elementName = generateWappElementName({ ...wapp, wappSessionId })

  proneRedundantWapps()
  const servIndexes = await wappSystemApi.getWappServIndexesAsync(wappId)

  submitWappSessionStartTime(wappSessionId)
  dispatchAddToWappPool({
    ...wapp,
    wappSessionId,
    stage: WappStage.LOADING,
    elementName,
    servIndexes,
  })

  return wappSessionId
}

export const restartWappSession = async (wappSessionId: string) => {
  const session = getWappSession(wappSessionId)
  if (!session) return

  removeFromWappPool(wappSessionId)

  await asyncDelay()
  await addToWappPool(session)
}

export const getWappInput = (wappSessionId: string) => {
  const { wappSessionId: sessionId, input } =
    findRunningWapp(wappSessionId) || {}
  return sessionId && input
}

export const setWappCustomActions = (
  wappSessionId: string,
  customActions: CustomAction[],
) => {
  if (getWappSession(wappSessionId))
    dispatchSetWappCustomActions(wappSessionId, customActions)
}

export const setWappBookmarkData = (
  wappSessionId: string,
  bookmarkData: BookmarkData,
) => {
  if (getWappSession(wappSessionId))
    dispatchSetWappBookmarkData(wappSessionId, bookmarkData)
}
